module.exports = __webpack_public_path__ + "./Andy_pbw_95471e5f18ffe94c014180a79f534388.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Andy_pbw.png
// module id = 583
// module chunks = 0